import { render } from "./GroupADSelect.vue?vue&type=template&id=134fb161&ts=true"
import script from "./GroupADSelect.vue?vue&type=script&lang=ts"
export * from "./GroupADSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__